var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 100,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB6100",
    d: "M102.854 10.73H59.042v78.645h43.812z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20014",
    d: "M61.858 50c0-15.937 7.511-30.104 19.09-39.27C72.498 3.957 61.754 0 50.07 0 22.428 0 0 22.396 0 50s22.428 50 50.07 50c11.684 0 22.428-3.958 30.982-10.73C69.37 80.105 61.858 65.939 61.858 50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5A400",
    d: "M162 50c0 27.604-22.428 50-50.071 50-11.683 0-22.427-3.958-30.981-10.73C92.63 80.105 100.037 65.939 100.037 50c0-15.937-7.51-30.104-19.09-39.27C89.503 3.957 100.247 0 111.93 0 139.572 0 162 22.396 162 50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M157.202 80.938v-1.563h.625v-.312h-1.669v.312h.626v1.563zm3.233 0v-1.98h-.521l-.626 1.355-.626-1.355h-.522v1.98h.313v-1.459l.522 1.25h.417l.522-1.25v1.459z"
  })));
};
export default SvgMasterCard;